import '@/components/button/styles.scss';

import { useRef, useState } from 'react';
import classNames from 'classnames';

import { BevelProps } from '@/components/button/types';

const Bevel = ({ children, className, color, disabled, isPressed }: BevelProps) => {
	const [pressed, setPressed] = useState(false);
	const bevelRef = useRef<HTMLDivElement | null>(null);

	const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
		if (disabled || isPressed) return;
		setPressed(true);
		let childClicked = false;
		const child = bevelRef.current?.children[0] as HTMLElement | undefined;
		if (child) {
			// check if was fired click event, if not - fire it
			const handleChildClick = () => {
				childClicked = true;
			};
			child.addEventListener('click', handleChildClick, { once: true });
			setTimeout(() => {
				if (!childClicked) {
					child.click();
				}
				setPressed(false);
				child.removeEventListener('click', handleChildClick);
			}, 300);
		}
	};

	const handleMouseUp = () => {
		if (isPressed) return;
		setPressed(false);
	};

	const handleMouseLeave = () => {
		if (isPressed) return;
		setPressed(false);
	};

	if (disabled) {
		return <>{children}</>;
	}

	return (
		<div
			className={classNames(
				'btn-bevel',
				className,
				color,
				(pressed || isPressed) && 'pressed',
			)}
			onMouseDown={handleMouseDown}
			onMouseUp={handleMouseUp}
			onMouseLeave={handleMouseLeave}
			ref={bevelRef}
		>
			{children}
		</div>
	);
};

export default Bevel;
